'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = arrayRepeat;
/**
 * 
 * Repeats content of array by structure or by index, returns flattened array.
 * 
 * @param   {array}   array 
 * @param   {number}  n 
 * @param   {boolean} [byIndex=false] 
 * @returns {array}
 *
 * @example
 * const values = [1, 2, 3];
 * arrayRepeat(values, 3) // returns: [1, 2, 3, 1, 2, 3, 1, 2, 3]
 *
 * @example
 * const values = [1, 2, 3];
 * arrayRepeat(values, 3, true) // returns: [1, 1, 1, 2, 2, 2, 3, 3, 3]
 */
function arrayRepeat(array) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var byIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (typeof array === 'undefined') {
        throw 'Cannot repeat array of type undefined';
    }

    if (byIndex) {
        return [].concat.apply([], array.map(function (item, i) {
            return Array(n).fill(array[i]);
        }));
    }
    return [].concat.apply([], Array.apply(null, Array(n)).map(function () {
        return array;
    }));
};
//# sourceMappingURL=arrayRepeat.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/arrayRepeat.js
 ** module id = 190
 ** module chunks = 0 1
 **/